import FillEditZone from './FillEditZone';

export default FillEditZone;
